<template lang="pug">
  .b-project-file-filters-container(:class="device")
    .__inputs-container
      BaseInput.__search(:value="filters.fileName" @input="changeFilters($event, 'fileName')" label="Поиск файла" iconName="search")
      BaseSelect.__sorter(:value="sorter" @input="changeSorter" :options="sorterOptions" labelOuter notSelectedLabel="Сортировать")
      BaseSelectMulti.__extension(:value="filters.extensions" @input="changeFilters($event, 'extensions')" :options="extensionOptions" labelOuter notSelectedLabel="Форматы")
      BaseSelectMulti.__users(:value="filters.members" @input="changeFilters($event, 'members')" :options="membersOptions" labelOuter notSelectedLabel="Автор")
      BaseSelect.__selected(:value="filters.selected" @input="changeFilters($event, 'selected')" :options="selectedOptions" labelOuter notSelectedLabel="Любые")
    .__right-container
      .__clear-icon(title="Очистить фильтр" @click="clearFilters")
        Icon(name="filter" pointer)
      .__tab-container
        BaseTabs(v-if="device !== 'mobile'" :tabs="tabsOptions" v-model="orientationType" blue big)
</template>

<script>
import BaseInput from '@/components/BaseInput.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import BaseSelectMulti from '@/components/BaseSelectMulti.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseTabs from '@/components/BaseTabs.vue';

export default {
  name: 'ProjectFileFiltersContainer',
  components: {
    BaseInput, BaseSelect, BaseTabs, BaseSelectMulti, BaseCheckbox,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    filesData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      orientationType: 'square',
      sorter: null,
      device: 'desktop',
      tabsOptions: [{ value: 'rectangle', icon: 'square-lined' }, { value: 'square', icon: 'square-dotted' }],
      sorterOptions: [
        { value: 'asc_createdAt', label: 'По дате добавления', icon: 'arrow-up' },
        { value: 'desc_createdAt', label: 'По дате добавления', icon: 'arrow-down' },
        { value: 'asc_fileName', label: 'По названию', icon: 'arrow-up' },
        { value: 'desc_fileName', label: 'По названию', icon: 'arrow-down' },
        { value: 'asc_userName', label: 'По автору', icon: 'arrow-up' },
        { value: 'desc_userName', label: 'По автору', icon: 'arrow-down' },
        { value: 'asc_size', label: 'По размеру', icon: 'arrow-up' },
        { value: 'desc_size', label: 'По размеру', icon: 'arrow-down' },
      ],
      selectedOptions: [{ value: true, label: 'Только выбранные' }, { value: false, label: 'Только не выбранные' }],
    };
  },
  watch: {
    orientationType(type) {
      this.$emit('changeOrientationType', type);
    },
  },
  mounted() {
    window.addEventListener('resize', this.checkResize);
    this.checkResize();
  },
  computed: {
    extensionOptions() {
      if (!this.filesData) return [];
      const extensions = {};
      this.filesData.forEach(fileData => {
        if (!extensions[fileData.file.extension]) extensions[fileData.file.extension] = true;
      });
      return Object.keys(extensions).map(extension => ({ value: extension, label: extension.toUpperCase() }));
    },
    membersOptions() {
      if (!this.filesData) return [];
      const members = {};
      this.filesData.forEach(fileData => {
        if (!members[`${fileData.file.owner.name} ${fileData.file.owner.surname}`]) members[`${fileData.file.owner.name} ${fileData.file.owner.surname}`] = fileData.file.owner.id;
      });

      return Object.keys(members).map(key => ({ label: key, value: members[key] }));
    },
  },
  methods: {
    checkResize() {
      if (window.innerWidth > 1200) {
        this.device = 'desktop';
      } else if (window.innerWidth < 768) {
        this.device = 'mobile';
        this.orientationType = 'square';
        this.$emit('changeOrientationType', 'square');
      } else {
        this.device = 'tablet';
      }
    },
    changeFilters(value, field) {
      this.$emit('changeFilters', value, field);
    },
    clearFilters() {
      this.$emit('clearFilters');
    },
    changeSorter(value) {
      this.sorter = value;
      this.$emit('changeSorter', value);
    },
  },
};
</script>

<style scoped lang="scss">
  .project-file-filters-container {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;

    &.mobile & {
      &__search, &__sorter, &__extension, &__users, &__selected {
        width: 100%;
        margin-right: 0;
      }
    }

    &__inputs-container {
      display: flex;
      align-items: flex-end;
      flex-wrap: wrap;
      gap: 16px;
    }

    &__right-container {
      display: flex;
      align-items: center;
    }

    &__clear-icon {
      cursor: pointer;
      width: 43px;
      height: 38px;
      background: var(--color-super-light);
      border-radius: 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 10px;
      stroke: var(--color-middle-gray);

      &:hover {
        stroke: var(--color-accent);
      }
    }

    &__search {
      width: 311px;
      margin-right: 22px;

      @media (max-width: 1400px) {
        margin-right: 0;
      }
    }

    &__sorter {
      width: 235px;
    }

    &__extension {
      width: 150px;
    }

    &__users {
      width: 164px;
    }

    &__selected {
      width: 130px;
      margin-right: 10px;
    }
  }

</style>
